import MuiInputAdornment from "@mui/material/InputAdornment";

export default function InputAdornment(props) {
  return <MuiInputAdornment {...props} />;
}
